import { NavLink } from "react-router-dom";
import {
  Sparkles, Target, CalendarClock, FileSearch, Activity,
  ClipboardList, FlaskConical,
} from "lucide-react";

// Iter 273 — Sub-navigation bar for the GOLD Intelligence area.
// Each item routes to a dedicated page so the previously-cluttered
// single-scroll `/gold` view is now a proper multi-page section.
const GOLD_SECTIONS = [
  { to: "/gold",                label: "Overview",       icon: Sparkles,      testid: "gold-nav-overview",     end: true },
  { to: "/gold/daily-picks",    label: "Daily Picks",    icon: Target,        testid: "gold-nav-daily-picks" },
  { to: "/gold/schedule",       label: "Schedule",       icon: CalendarClock, testid: "gold-nav-schedule" },
  { to: "/gold/dossier",        label: "Match Dossier",  icon: FileSearch,    testid: "gold-nav-dossier" },
  { to: "/gold/accuracy",       label: "Accuracy",       icon: Activity,      testid: "gold-nav-accuracy" },
  { to: "/gold/miss-analyzer",  label: "Miss Analyzer",  icon: ClipboardList, testid: "gold-nav-miss" },
  { to: "/gold/expert",         label: "Expert Mode",    icon: FlaskConical,  testid: "gold-nav-expert" },
];

export default function GoldSubNav() {
  return (
    <nav
      className="mb-6 sticky top-[64px] z-30 -mx-4 px-4 sm:mx-0 sm:px-0 sm:relative sm:top-auto"
      data-testid="gold-sub-nav"
    >
      <div className="flex gap-1.5 overflow-x-auto scrollbar-none pb-1 bg-black/85 backdrop-blur-md border border-amber-500/20 rounded-full px-1.5 py-1.5">
        {GOLD_SECTIONS.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `flex items-center gap-1.5 shrink-0 px-3.5 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-widest transition-all whitespace-nowrap ${
                isActive
                  ? "bg-gradient-to-r from-amber-500 to-yellow-400 text-black shadow-md shadow-amber-500/30"
                  : "text-amber-500/70 hover:text-amber-200 hover:bg-amber-500/10"
              }`
            }
          >
            <Icon className="w-3.5 h-3.5" />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
